import styled from "styled-components";

interface Props {
  length: number;
  children: React.ReactNode;
  index: number;
}

export const RoutePinContainer: React.FC<Props> = ({
  length,
  children,
  index,
}) => {
  return (
    <RouteMarkerContainer length={length} index={index}>
      <>{children}</>
    </RouteMarkerContainer>
  );
};

interface RouteMarkerContainerProps {
  length: number;
  index: number;
}

const RouteMarkerContainer = styled.div<RouteMarkerContainerProps>`
  display: flex;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  align-items: center;
  z-index: ${(props) => 999 + Number(props.index)};

  &:hover {
    z-index: 9000;
  }

  & > div:not(:first-child) {
    margin-left: -8px;
  }
`;
